import { Fragment, PureComponent } from 'react';
import PortalIdParser from 'PortalIdParser';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import UIButton from 'UIComponents/button/UIButton';
import { FileButton } from 'foundations-components/transitional/components/FileButton';
import { View } from 'foundations-components/transitional/components/View';
import UILink from 'UIComponents/link/UILink';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
//@ts-expect-error No types config
import FileUploadComponent from 'FileManagerLib/components/FileUploadComponent';
import { VISIBLE_IN_APP_PUBLIC_TO_ALL_INDEXABLE } from 'file-manager-components/constants/fileAccess';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
class FileDropZone extends PureComponent {
  constructor(props) {
    super(props);
    this.renderContents = this.renderContents.bind(this);
  }
  renderContents(handleUpload) {
    const {
      browseText,
      contentAssistanceEnabled,
      fieldKey,
      filteredExtensions,
      onClick,
      onClickGenerate,
      readOnly,
      uploadText,
      showGenerate
    } = this.props;
    const seleniumKey = fieldKey || 'file';
    const formattedExtensions = filteredExtensions && filteredExtensions.map(ext => `.${ext}`);
    const settingsLink = `/ai-settings/${PortalIdParser.get()}?source=image-field-generate`;
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsxs(View, {
        marginBlockEnd: showGenerate ? '300' : '100',
        children: [/*#__PURE__*/_jsx(FileButton, {
          accept: formattedExtensions,
          "data-selenium": `${seleniumKey}:upload`,
          disabled: readOnly,
          onChange: handleUpload,
          paddingInline: showGenerate ? undefined : '600',
          size: "small",
          use: "tertiary-light",
          children: uploadText
        }), showGenerate && onClickGenerate && /*#__PURE__*/_jsx(UITooltip, {
          disabled: contentAssistanceEnabled !== false,
          title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
            message: "ContentComponents.cmv2.fields.image.generateDisabledTooltip_jsx",
            elements: {
              UILink
            },
            options: {
              settingsLink
            }
          }),
          children: /*#__PURE__*/_jsx(UIButton, {
            "data-selenium": `${seleniumKey}:generate`,
            className: "m-left-3",
            disabled: readOnly || !contentAssistanceEnabled,
            onClick: onClickGenerate,
            size: "small",
            use: "tertiary",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "ContentComponents.cmv2.fields.image.generateWithAI"
            })
          })
        })]
      }), /*#__PURE__*/_jsx(UIButton, {
        "data-selenium": `${seleniumKey}:browse`,
        className: "m-left-0",
        disabled: readOnly,
        onClick: onClick,
        use: "link",
        children: browseText
      })]
    });
  }
  render() {
    const {
      filteredExtensions,
      filterType,
      onChange,
      uploadedFileAccess
    } = this.props;
    return /*#__PURE__*/_jsx(FileUploadComponent, {
      filteredExtensions: filteredExtensions,
      filterType: filterType,
      onChange: onChange,
      uploadButtonRenderer: this.renderContents,
      uploadedFileAccess: uploadedFileAccess,
      renderContext: "ContentComponents-FileDropZone"
    });
  }
}
FileDropZone.defaultProps = {
  uploadedFileAccess: VISIBLE_IN_APP_PUBLIC_TO_ALL_INDEXABLE
};
export default FileDropZone;